import { ArrowLeft } from "lucide-react";

type Props = {
  onBack: () => void;
};

export function MessageReaderBackBar({ onBack }: Props) {
  return (
    <div className="shrink-0 border-b border-[var(--mail-border-soft)] bg-[var(--mail-surface)] md:hidden">
      <button
        type="button"
        onClick={onBack}
        className="flex w-full items-center gap-2 px-3 py-2.5 text-sm font-medium text-[var(--mail-accent)]"
      >
        <ArrowLeft className="h-4 w-4" aria-hidden />
        Retour à la liste
      </button>
    </div>
  );
}
